module.exports = __webpack_public_path__ + "static/media/icon-tick-green.e02c7c88.svg";